import React from "react";
import { Show } from "components/core";
import numeral from "numeral";

type Props = {
  data: any;
};

const TreatyDeductionFormSummary = ({ data }: Props) => {
  return (
    <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3">
      <div>
        <div className="grid grid-cols-3 gap-6">
          <div className="">
            <span className="block text-sm font-light text-gray-700">
              New Policy Number
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {data?.policy_number || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Co-Insurance Share (%)
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {data?.co_insurance_share || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Payment Type
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {Object.keys(JSON.parse(data?.payment_type || "{}"))
                .at(0)
                ?.toString()
                ?.toLocaleUpperCase() || "N/A"}
            </div>
          </div>
          <Show
            if={Boolean(
              Object.keys(JSON.parse(data?.payment_type || "{}"))
                .at(0)
                ?.toString() === "instalment"
            )}
          >
            <div>
              <span className="block text-sm font-light text-gray-700">
                No. of Installments
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {Object.values(JSON.parse(data?.payment_type || "{}"))
                  .at(0)
                  ?.toString() || "N/A"}
              </div>
            </div>
          </Show>
          <Show if={Boolean(data?.ex_currency)}>
            <div>
              <span className="block text-sm font-light text-gray-700">
                Exchange Rate ({data?.ex_currency})
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {data?.ex_rate || "N/A"}
              </div>
            </div>
          </Show>
          <div>
            <span className="block text-sm font-light text-gray-700">Rate</span>
            <div className="mt-1 block w-full sm:text-sm">
              {data?.rate || "N/A"}
            </div>
          </div>
          <div className="">
            <span className="block text-sm font-light text-gray-700">
              Insured
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {data?.insured_by || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Sum Insured
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {data?.sum_insured || "N/A"}
            </div>
          </div>

          <div>
            <span className="block text-sm font-light text-gray-700">
              Premium
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {data?.premium || "N/A"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TreatyDeductionFormSummary;
